import { FC, useContext } from 'react'
import { Sparkles } from 'lucide-react'
import LocalizationContext from 'shared/contexts/LocalizationContext'
import Typewriter from 'typewriter-effect'

export const TYPEWRITER_DELAY = 25
export const TYPEWRITER_SCROLL_INTERVAL = 500
export const TYPEWRITER_CURSOR_COLOR = '#10b981'

type Props = {
  locale: string
  scrollToBottom: () => void
  overallSummary: string
  onWritingDone: () => void
  animationOn?: boolean
}

const AISummary: FC<Props> = ({
  locale,
  scrollToBottom,
  overallSummary,
  onWritingDone,
  animationOn
}) => {
  const { getString } = useContext(LocalizationContext)

  const renderContent = () => {
    if (animationOn) {
      return (
        <Typewriter
          options={{ cursor: '●', delay: TYPEWRITER_DELAY }}
          onInit={(typewriter) => {
            // Start scroll interval during typing
            const scrollInterval = setInterval(() => {
              scrollToBottom()
            }, TYPEWRITER_SCROLL_INTERVAL)

            typewriter
              .callFunction((state) => {
                if (state.elements.cursor) {
                  state.elements.cursor.style.color = TYPEWRITER_CURSOR_COLOR
                }
              })
              .typeString(overallSummary)
              .start()
              .callFunction(() => {
                clearInterval(scrollInterval)
                onWritingDone()
                const cursor = document.querySelector('.Typewriter__cursor')
                if (cursor) {
                  ;(cursor as HTMLElement).style.display = 'none'
                }
              })
          }}
        />
      )
    } else {
      return overallSummary
    }
  }

  return (
    <div className={`bg-white rounded-lg shadow-sm p-6 animate-fadeIn mb-6`}>
      <div className='flex items-center gap-2 mb-4'>
        <Sparkles className='text-blue-500' size={20} />
        <h2 className='text-lg font-semibold text-gray-900'>
          {getString('recap_ai_analysis', locale)}
        </h2>
      </div>
      <div className='text-gray-700 break-words'>{renderContent()}</div>
    </div>
  )
}

export default AISummary
